export const dateFormat = "DD/MM/YYYY";
export const filterOptions = [
  { name: "Name", value: "name" },
  { name: "Date Active", value: "activationDate" },
  { name: "Date Deactivated", value: "deactivationDate" },
  { name: "Status", value: "status" },
  { name: "Owner", value: "owner" },
];

export const STATUS_LIST = ["Draft", "Active", "Inactive"];
export const REGISTRATION_CATEGORY_LIST = ["Residential", "Commercial"];
export const RANGE_OPTIONS = [
  {
    title: "From-To",
    value: "fromTo",
  },
  {
    title: "From",
    value: "from",
  },
  {
    title: "To",
    value: "to",
  },
];

export const STATUS_COLOR_MAP = {
  Active: {
    color: "#17C347",
    backgroundColor: "#D8FFE3",
  },
  Inactive: {
    color: "#FF0000",
    backgroundColor: "#FF00001A",
  },
  Draft: {
    color: "#DB6607",
    backgroundColor: "#DB660726",
  },
};

export const VALIDATION_RULES = [{ required: true, message: "Please enter value" }];
